<template>
  <v-card>
    <template>
      <v-card-title>
        Forest Trees
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search by reviewer name, email or text"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
    </template>
    <template>
      <v-data-table
        :headers="headers"
        :items="listOfTrees"
        :server-items-length="totalAmount"
        item-key="id"
        class="elevation-1"
        v-model="refundTrees"
        show-select
        :loading="loading"
        loading-text="Loading... Please wait"
        :options.sync="options"
      >
        <template v-slot:[`item.name`]="{ item }">
          <v-menu
            v-model="item.showTreeSelector"
            :close-on-content-click="false"
            offset-y
          >
            <template v-slot:activator="{ on }">
              <span
                v-on="on"
                style="cursor: pointer; text-decoration: underline"
              >
                <span>{{ item.name }}</span>
              </span>
            </template>
            <v-list dense>
              <v-list-item style="cursor: pointer">
                <v-list-item-title class="font-weight-medium">
                  <a
                    :href="item.url"
                    target="_blank"
                    style="text-decoration: none"
                  >
                    Go to Review 🔗
                  </a>
                  <v-icon>mdi-open-in-new</v-icon>
                </v-list-item-title>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item
                @click="copyTreeEntity(item, 'Tree Name', item.name)"
                style="cursor: pointer"
              >
                <v-list-item-title class="font-weight-medium">
                  Copy Tree Name
                </v-list-item-title>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item
                @click="copyTreeEntity(item, 'Tree ID', item.id)"
                style="cursor: pointer"
              >
                <v-list-item-title class="font-weight-medium">
                  Copy Tree ID
                </v-list-item-title>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item
                @click="copyTreeEntity(item, 'Tree Unique ID', item.uniqueId)"
                style="cursor: pointer"
              >
                <v-list-item-title class="font-weight-medium">
                  Copy Tree Unique ID
                </v-list-item-title>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item
                @click="
                  copyTreeEntity(
                    item,
                    'Planting Timestamp',
                    item.countingTimestamp
                  )
                "
                style="cursor: pointer"
              >
                <v-list-item-title class="font-weight-medium">
                  Copy Planting Timestamp
                </v-list-item-title>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item
                @click="copyTreeEntity(item, 'Tree Platform ID', item.platform)"
                style="cursor: pointer"
              >
                <v-list-item-title class="font-weight-medium">
                  Copy Tree Platform ID
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <!--<template v-slot:[`item.date`]="{ item }">
          <span v-if="!isProd">
            <a @click="openDateDialog(item)">{{ formatDate(item.date) }}</a>
          </span>
          <span v-else>{{ formatDate(item.date) }}</span>
        </template>-->
        <template v-slot:[`item.createdAt`]="{ item }">
          <span>{{ formatDate(item.createdAt) }}</span>
        </template>
        <template v-slot:[`item.projectId`]="{ item }">
          <v-tooltip top open-delay="1000">
            <template v-slot:activator="{ on }">
              <span v-on="on" v-if="item.projectId">
                <span v-if="item.projectId">
                  {{
                    $options.PROJECT_TYPES.find(
                      (p) => Number(p.id) === Number(item.projectId)
                    )
                      .name.split("-")[0]
                      .split(" ")[0]
                  }}
                </span>
              </span>
            </template>
            <span v-if="item.projectId">{{
              $options.PROJECT_TYPES.find(
                (p) => Number(p.id) === Number(item.projectId)
              )
                .name.split("-")[0]
                .split(" ")[0]
            }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.platformType`]="{ item }">
          <span v-if="item.type === 'review'">
            <platforms-logo :platforms="[item.platformType]"></platforms-logo>
          </span>
        </template>
        <template v-slot:[`item.uniqueId`]="{ item }">
          <div class="d-flex">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  text
                  icon
                  color="primary"
                  @click="downloadCertificate(item)"
                >
                  <v-icon>description</v-icon>
                </v-btn>
              </template>
              <span>Download certificate</span>
            </v-tooltip>
          </div>
        </template>
        <template v-slot:[`item.stripeInvoiceNumber`]="{ item }">
          <router-link
            v-if="item.stripeInvoiceId"
            :to="{
              name: 'InvoiceView',
              params: { id: item.stripeInvoiceId },
            }"
          >
            {{ item.stripeInvoiceNumber }}
          </router-link>
        </template>
        <template v-slot:top>
          <div>
            <v-dialog
              v-model="dialogGenerateTreeReply"
              persistent
              max-width="500px"
              @click:outside="closeGenerateTreeReply"
            >
              <v-card>
                <v-card-title class="text-h5">
                  Do you want to generate a reply for "{{ editedItem.name }}"?
                </v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue-darken-1"
                    variant="text"
                    :disabled="loading"
                    @click="closeGenerateTreeReply"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    color="blue-darken-1"
                    variant="text"
                    :disabled="loading"
                    @click="generateTreeReplyConfirm"
                  >
                    OK
                  </v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog
              v-model="dialogDelete"
              persistent
              max-width="500px"
              @click:outside="closeDelete"
            >
              <v-card>
                <v-card-title class="text-h5">
                  Are you sure you want to delete the tree from "{{
                    editedItem.name
                  }}"?
                </v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue-darken-1"
                    variant="text"
                    :disabled="loading"
                    @click="closeDelete"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    color="blue-darken-1"
                    variant="text"
                    :disabled="loading"
                    @click="deleteTreeConfirm"
                  >
                    OK
                  </v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog
              v-model="dialogDate"
              persistent
              max-width="500px"
              @click:outside="closeDateDialog"
            >
              <v-card>
                <v-card-title class="text-h5">Edit Tree Date</v-card-title>
                <v-card-text>
                  <v-text-field
                    v-model="editedDate"
                    label="Date and Time"
                    type="datetime-local"
                    @input="editedDate"
                  ></v-text-field>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue-darken-1"
                    variant="text"
                    @click="dialogDate = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    color="blue-darken-1"
                    variant="text"
                    @click="updateTreeDate"
                  >
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <div class="d-flex">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  text
                  icon
                  color="primary"
                  @click="deleteTree(item)"
                  :disabled="!!item.stripeInvoiceId"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </template>
              <span>Remove tree</span>
            </v-tooltip>
          </div>
        </template>
        <template v-slot:[`item.text`]="{ item }">
          <span
            v-if="item.text"
            style="cursor: pointer; text-decoration: underline"
            @click="showFullText(item)"
          >
            {{ item.text.substring(0, 20) + "..." }}
          </span>
        </template>
        <template v-slot:[`item.generatedReplies`]="{ item }">
          <span v-if="item.generatedReplies.length > 0">
            {{ item.generatedReplies.length }}
          </span>
          <span v-else>
            <v-tooltip
              v-if="
                item.generatedReplies.length === 0 && item.type === 'review'
              "
              top
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  class="mr-1"
                  text
                  icon
                  color="primary"
                  @click="generateTreeReply(item)"
                >
                  <v-icon>refresh</v-icon>
                </v-btn>
              </template>
              <span>Generate tree reply</span>
            </v-tooltip>
          </span>
        </template>
      </v-data-table>
    </template>
    <template>
      <template>
        <v-progress-linear
          :active="actionsLoading"
          :indeterminate="actionsLoading"
          absolute
          bottom
          color="indigo darken-2"
        ></v-progress-linear>
      </template>
      <v-card-text v-if="refundTrees.length > 0">
        {{ refundTrees.length }} selected tree(s):
        {{ refundTrees.map((tree) => tree.name).join(", ") }}
      </v-card-text>
      <v-card-text v-else>All trees</v-card-text>
      <v-alert v-if="creditNoteError" dense outlined type="error">
        {{ creditNoteError }}
      </v-alert>
    </template>
    <template>
      <v-btn
        color="primary"
        @click="previewCreditNote()"
        :disabled="selectedStripeInvoiceIds.length !== 1 && !invoice"
      >
        Preview Credit Note
      </v-btn>
      <v-divider class="mx-4" inset vertical></v-divider>
    </template>
    <template v-if="previewedCreditNote">
      <v-card-text>
        Total credit note: {{ previewedCreditNote.total / 100 }}
        {{ previewedCreditNote.currency }}
      </v-card-text>
      <v-card-text v-if="isIssueCreditNoteAllowed">
        <template v-if="creditNoteReasons">
          <v-row>
            <v-col cols="3">
              <v-select
                :items="creditNoteReasons"
                density="compact"
                value="other"
                v-model="reason"
                item-text="name"
                item-value="value"
              ></v-select>
            </v-col>
          </v-row>
        </template>
        <template v-if="creditNoteMemosDE && creditNoteMemosEN">
          <v-row>
            <v-col cols="3">
              <v-select
                label="Memo templates"
                :items="
                  invoice.language === 'de'
                    ? creditNoteMemosDE
                    : creditNoteMemosEN
                "
                density="compact"
                value="other"
                v-model="memo"
                item-text="item"
                item-value="item"
              ></v-select>
            </v-col>
          </v-row>
        </template>
        <v-responsive>
          <v-text-field
            label="What's the reason for the removal"
            v-model="memo"
          ></v-text-field>
        </v-responsive>
      </v-card-text>
      <v-dialog v-model="dialog" persistent max-width="550">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            :disabled="!isIssueCreditNoteAllowed"
            color="primary"
            dark
            v-bind="attrs"
            v-on="on"
          >
            Issue Credit Note
          </v-btn>
        </template>
        <v-card>
          <v-card-title class="text-h5">Issue Credit Note</v-card-title>
          <v-card-text>
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td style="width: 50px">Number</td>
                    <td>{{ previewedCreditNote.number }}</td>
                  </tr>
                  <tr>
                    <td>Memo</td>
                    <td>{{ memo }}</td>
                  </tr>
                  <tr>
                    <td>Reason</td>
                    <td>{{ reason }}</td>
                  </tr>
                  <tr>
                    <td>How to credit</td>
                    <td>{{ credit }}</td>
                  </tr>
                  <tr>
                    <td>Total</td>
                    <td>
                      {{ previewedCreditNote.total / 100 }}
                      {{ previewedCreditNote.currency }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="dialog = false">
              Cancel
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              @click="
                dialog = false;
                issueCreditNote();
              "
            >
              Confirm
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <v-dialog v-model="dialogFullText" max-width="500">
      <v-card>
        <v-card-title>{{ selectedReview.name }}</v-card-title>
        <v-card-text>
          <i>"{{ selectedReview.text }}"</i>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogFullText = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <success-snackbar v-model="showSuccessMessage" :message="successMessage" />
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import { API } from "../../api";
import { formatDate } from "../../helpers";
import { writeToClipboard } from "../../utils/copyText";
import PlatformsLogo from "../Base/PlatformsLogo.vue";
import SuccessSnackbar from "../Base/SuccessSnackbar.vue";

import {
  DEFAULT_ITEMS_PER_PAGE,
  INVOICE_STATUS,
  INVOICE_TYPES,
  PROJECT_TYPES,
} from "../../constants";

export default {
  name: "CreditNote",
  components: {
    PlatformsLogo,
    SuccessSnackbar,
  },
  DEFAULT_ITEMS_PER_PAGE,
  INVOICE_STATUS,
  INVOICE_TYPES,
  PROJECT_TYPES,
  props: {
    forestId: {
      type: String,
      required: true,
    },
    trees: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formatDate,
      selectable: false,
      memo: null,
      reason: null,
      dialog: false,
      dialogDelete: false,
      dialogGenerateTreeReply: false,
      credit: "refund",
      listOfTrees: this.trees.data,
      refundTrees: [],
      selectedStripeInvoiceIds: [],
      isIssueCreditNoteAllowed: false,
      toSubmitInvoiceLineItems: null,
      previewedCreditNote: null,
      creditNoteError: null,
      loading: false,
      actionsLoading: false,
      projectId: null,
      search: "",
      invoice: null,
      showSuccessMessage: false,
      successMessage: "",
      creditNoteTypes: [
        {
          name: "Credit Balance",
          value: "credit_balance",
        },
        {
          name: "Refund",
          value: "refund",
        },
      ],
      creditNoteReasons: [
        {
          name: "Credit note reason",
          value: null,
        },
        {
          name: "Duplicate charge",
          value: "duplicate",
        },
        {
          name: "Fraudulent charge",
          value: "fraudulent",
        },
        {
          name: "Order change",
          value: "order_change",
        },
        {
          name: "Product unsatisfactory",
          value: "product_unsatisfactory",
        },
      ],
      creditNoteMemosDE: [
        "[NUMBER] Baum wurde erstattet, weil der Kunde den Baum löschen wollte (gefälschte Bewertung).",
        "[NUMBER] gelöschte Bäume.",
        "[NUMBER] Baum wurde erstattet, weil der Kunde den Baum löschen wollte (falscher Name) und stattdessen einen anderen gepflanzt hat.",
        "Löschung [NUMBER] Baumes, da Bewertung auf [PLATFORM] gelöscht wurde.",
        "Druckbestellung mit dem falschen Standort, Kunde will mit anderem Standort Karten bestellen.",
        "Gutschrift und Rückerstattung auf Basis umgehender Kündigung am finalen Testtag.",
        "Kunde hat falsche Anzahl von Karten bestellt, bestellt gleich [NUMBER] Stück. Credit Balance wird angewandt.",
      ],
      creditNoteMemosEN: [
        "[NUMBER] tree refunded because customer wanted to delete tree (fake review).",
        "[NUMBER] deleted trees.",
        "[NUMBER] tree refunded because customer wanted to delete tree (wrong name) & planted another one instead.",
        "Customer's sub ([DATE] to [DATE]) was deactivated because of uncollectable invoice. We reactivated it -> new sub [DATE] to [DATE] -> refund of [DATE_RANGE].",
        "Refund because account was deactivated for [DATE_RANGE]",
        "Customer cancelled another [NUMBER] forests -> just [NUMBER] forest left.",
        "Customer has [NUMBER] forests and not [NUMBER] -> refund of [NUMBER] forest.",
        "Print order cancelled.",
        "Customer wishes to cancel.",
        "Unused [PLAN_NAME] Plan",
        "Refund for [NUMBER] months because customer cancelled.",
        "Refund because customer wants to stop participating.",
      ],
      headers: [
        { text: "Name", value: "name", width: "100" },
        { text: "Email", value: "email", width: "100" },
        { text: "Planted At", value: "createdAt", width: "200" },
        { text: "Score", value: "score", align: "center", width: "50" },
        { text: "Project", value: "projectId", width: "50" },
        {
          text: "Platform Type",
          value: "platformType",
          align: "center",
          width: "50",
        },
        { text: "Tree Type", value: "type", align: "center", width: "50" },
        { text: "Text", value: "text", sortable: false, width: "200" },
        {
          text: "Invoice Number",
          value: "stripeInvoiceNumber",
          sortable: false,
          width: "100",
        },
        {
          text: "Certificate",
          value: "uniqueId",
          align: "center",
          sortable: false,
          width: "50",
        },
        {
          text: "Generated Replies",
          value: "generatedReplies",
          align: "center",
          sortable: false,
          width: "50",
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          width: "50",
        },
      ],
      editedIndex: -1,
      editedItem: {
        id: "",
        name: "",
        date: "",
        score: "",
        plantingProject: "",
        occasion: "",
        platform: "",
        platformType: "",
        type: "",
        text: "",
        invoiceNumber: "",
      },
      defaultItem: {
        name: "",
        date: "",
        score: "",
        plantingProject: "",
        occasion: "",
        platformType: "",
        type: "",
        text: "",
        invoiceNumber: "",
      },
      options: {
        page: 1,
        itemsPerPage: DEFAULT_ITEMS_PER_PAGE,
        sortBy: ["createdAt"],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: false,
      },
      totalAmount: this.trees.count,
      dialogDate: false,
      editedDate: null,
      editedTreeId: null,
      dialogFullText: false,
      selectedReview: {
        name: "",
        text: "",
      },
    };
  },
  watch: {
    refundTrees: {
      async handler(val) {
        this.creditNoteError = false;
        if (!val) {
          this.refundTrees = [];
        }
        this.selectedStripeInvoiceIds =
          val?.length > 0
            ? [...new Set(val.map((x) => x.stripeInvoiceId).filter((x) => !!x))]
            : [];
        if (this.selectedStripeInvoiceIds.length > 1) {
          this.creditNoteError =
            "Please select only trees from the same invoice";
        }
        this.isIssueCreditNoteAllowed = false;
      },
      immediate: true,
      deep: true,
    },
    selectedStripeInvoiceIds: {
      async handler(val) {
        const selectedInvoiceId = val[0];
        if (
          selectedInvoiceId &&
          selectedInvoiceId !== this.invoice?.stripeInvoiceId
        ) {
          await this.getInvoice(selectedInvoiceId);
        }
      },
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dialogGenerateTreeReply(val) {
      val || this.closeGenerateTreeReply();
    },
    projectId: {
      handler: "debounceFetching",
    },
    search: {
      handler: "debounceFetching",
    },
    options: {
      handler: "debounceFetching",
      deep: true,
    },
  },
  computed: {
    ...mapGetters(["isProd"]),
    searchQuery() {
      const trimmedSearch = this.search.trim();
      return trimmedSearch === "" ? null : trimmedSearch;
    },
    emptyTrees() {
      return this.refundTrees.filter((t) => !t.invoiceNumber);
    },
  },
  methods: {
    debounceFetching() {
      if (this.timerId) {
        clearTimeout(this.timerId);
      }

      this.isIssueCreditNoteAllowed = false;
      this.timerId = setTimeout(() => {
        this.getForestTrees();
      }, 500);
    },
    async getInvoice(stripeInvoiceId) {
      this.actionsLoading = true;
      await API.getInvoice(stripeInvoiceId)
        .then((response) => {
          this.invoice = response;
        })
        .catch((error) => {
          this.creditNoteError = `Error: ${error.response?.data?.message}`;
        })
        .finally(() => {
          this.actionsLoading = false;
        });
    },
    async getForestTrees() {
      this.loading = true;

      await API.getForestTrees({
        forestId: this.forestId,
        params: {
          sortBy: this.options.sortBy[0],
          order: this.options.sortDesc[0] ? "desc" : "asc",
          page: this.options.page,
          pageSize:
            this.options.itemsPerPage === -1 ? 0 : this.options.itemsPerPage,
          query: this.searchQuery,
        },
      })
        .then((response) => {
          this.listOfTrees = response.data;
          this.totalAmount = response.count;
        })
        .catch((error) => {
          this.creditNoteError = `Error: ${error.response?.data?.message}`;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async previewCreditNote() {
      this.creditNoteError = false;
      this.actionsLoading = true;
      const previewTreeIds = this.refundTrees;

      const uniqueStripeInvoiceIds = [
        ...new Set(this.refundTrees.map((x) => x.stripeInvoiceId)),
      ];

      if (uniqueStripeInvoiceIds.length === 0) {
        this.creditNoteError = "Please select at least one tree";
        this.actionsLoading = false;
        return;
      }

      if (uniqueStripeInvoiceIds.length > 1) {
        this.creditNoteError = "Please select only trees from the same invoice";
        this.actionsLoading = false;
        return;
      }

      const treeStripePriceIds = this.refundTrees.map((x) => x.stripePriceId);

      this.toSubmitInvoiceLineItems = this.invoice?.lines
        ?.filter((x) => treeStripePriceIds.includes(x.priceId))
        ?.map((el) => {
          const item = { id: el.id };
          if (previewTreeIds?.length > 0) {
            if (
              previewTreeIds.filter((tr) => tr.projectId === el.projectId)
                .length > 0
            ) {
              item.treeIds = previewTreeIds
                .filter((tr) => tr.projectId === el.projectId)
                .map((tx) => tx.id);
            } else {
              delete item.id;
              return;
            }
          } else {
            item.projectId = el.projectId;
          }
          return item;
        })
        .filter((item) => !!item);

      await API.previewCreditNote({
        stripeInvoiceId: this.invoice.stripeInvoiceId,
        data: { invoiceLineItems: this.toSubmitInvoiceLineItems },
      })
        .then((response) => {
          this.previewedCreditNote = response;
          this.isIssueCreditNoteAllowed = true;
        })
        .catch((error) => {
          this.creditNoteError = `Error: ${error.response?.data?.message}`;
        })
        .finally(() => {
          this.actionsLoading = false;
        });
    },
    async issueCreditNote() {
      this.actionsLoading = true;
      await API.issueCreditNote({
        stripeInvoiceId: this.invoice.stripeInvoiceId,
        data: {
          invoiceLineItems: this.toSubmitInvoiceLineItems,
          memo: this.memo,
          reason: this.reason,
          credit: this.credit,
        },
      })
        .then(() => {
          this.$router.push({
            name: "Company",
            params: { id: this.invoice.ownedBy },
          });
        })
        .catch((error) => {
          this.creditNoteError = `Error: ${error.response?.data?.message}`;
        })
        .finally(() => {
          this.actionsLoading = false;
        });
    },
    deleteTree(item) {
      this.editedIndex = this.listOfTrees.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    generateTreeReply(item) {
      this.editedIndex = this.listOfTrees.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogGenerateTreeReply = true;
    },
    async generateTreeReplyConfirm() {
      this.loading = true;
      await API.generateTreeReply({
        forestId: this.forestId,
        treeId: this.editedItem.id,
      })
        .then((response) => {
          this.listOfTrees[this.editedIndex].generatedReplies.push(response);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
          this.closeGenerateTreeReply();
        });
    },
    async deleteTreeConfirm() {
      this.listOfTrees.splice(this.editedIndex, 1);
      this.loading = true;
      await API.removeTree({
        forestId: this.forestId,
        treeId: this.editedItem.id,
      })
        .then(() => {
          this.totalAmount -= 1;
        })
        .catch((error) => {
          this.creditNoteError = `Error: ${error.response?.data?.message}`;
        })
        .finally(() => {
          this.loading = false;
          this.closeDelete();
        });
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    closeGenerateTreeReply() {
      this.dialogGenerateTreeReply = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    openDateDialog(item) {
      this.editedDate = this.formatDateTimeLocal(item.date);
      this.editedTreeId = item.id;
      this.dialogDate = true;
    },
    closeDateDialog() {
      this.dialogDate = false;
      this.editedTreeId = null;
      this.editedDate = null;
    },
    async updateTreeDate() {
      this.loading = true;
      try {
        await API.updateTreeDate({
          forestId: this.forestId,
          treeId: this.editedTreeId,
          date: this.editedDate,
        });

        // Update the tree date in the local list
        const treeIndex = this.listOfTrees.findIndex(
          (t) => t.id === this.editedTreeId
        );
        if (treeIndex !== -1) {
          this.listOfTrees[treeIndex].date = this.editedDate;
        }

        this.dialogDate = false;
      } catch (error) {
        this.creditNoteError = `Error: ${error.response?.data?.message}`;
      } finally {
        this.loading = false;
      }
    },
    formatDateTimeLocal(date) {
      if (!date) return null;
      return new Date(date).toISOString().slice(0, 16);
    },
    showFullText(item) {
      this.selectedReview = item;
      this.dialogFullText = true;
    },
    async downloadCertificate(item) {
      window.location.href = `${process.env.VUE_APP_API_URL}/v1/forests/${this.forestId}/trees/${item.uniqueId}/certificate`;
    },
    async copyToClipboard(label, value, key) {
      try {
        await writeToClipboard(String(value));
        this.copiedKey = key;
        // Show success message
        this.successMessage = `${label} successfully copied to clipboard!`;
        this.showSuccessMessage = true;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("Failed to copy " + label, e);
      } finally {
        clearTimeout(this.resetTimer);
        this.resetTimer = setTimeout(() => (this.copiedKey = null), 1500);
      }
    },
    copyTreeEntity(item, type, value) {
      item.showTreeSelector = false;
      this.copyToClipboard(type, value, type);
    },
  },
};
</script>
